import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.addEventListener('selectInputValueChanged', this.switchPageView);
  }

  switchPageView = (event) => {
    const { value } = event.target;
    const targetElement = document.getElementById(`${value}_option`);
    const url = new URL(targetElement.dataset.url);
    window.location.href = url.href;
  };
}
